import { render, staticRenderFns } from "./users-table.vue?vue&type=template&id=2c3b0242"
import script from "./users-table.ts?vue&type=script&lang=js&external"
export * from "./users-table.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports